<div [id]="nodeId" class="chart line">&nbsp;</div>